/**
 * How much rem-sized UI is scaled right now: the root font size ÷ 16, i.e. `--k-scale` (set per
 * device class by DeviceModeContext; the root is 16px × --k-scale whatever the browser's font
 * setting). 1 on phones and desktops, and whenever it cannot be read (no DOM, jsdom).
 *
 * For JS that needs a pixel number for a size that is rem in CSS: placement math in popovers,
 * row-height estimates before the first measure. It reads the live value, so it works outside
 * <DeviceModeProvider> too (the ui library, tests); inside React code under the provider,
 * `useUiScale().scale` is the same knob.
 */
export function readRemScale(): number {
  if (typeof document === 'undefined' || typeof getComputedStyle !== 'function') return 1;
  const rootPx = parseFloat(getComputedStyle(document.documentElement).fontSize);
  return Number.isFinite(rootPx) && rootPx > 0 ? rootPx / 16 : 1;
}

/** `px` design pixels (sizes at scale 1) in current CSS pixels. */
export function remPx(px: number): number {
  return px * readRemScale();
}
